import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  AgentTraits: [],
  audioList: [],
  totalAudioCount: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "APPEARANCELIST",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getAgentTraits.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getAgentTraits.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      AgentTraits: payload.data,
    }));
    builder.addCase(Act.getAgentTraits.rejected, (state, action) => ({
      ...state,
      loading: false,
      AgentTraits: [],
    }));
    builder.addCase(Act.createAgent.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.createAgent.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.createAgent.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(Act.getAudioLibrary.pending, (state, action) => ({
      ...state,
      loading: true,
      totalAudioCount: 0,
    }));
    builder.addCase(Act.getAudioLibrary.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      audioList: payload.data.voices,
      totalAudioCount: payload.totalcount,
    }));
    builder.addCase(Act.getAudioLibrary.rejected, (state, action) => ({
      ...state,
      loading: false,
      audioList: [],
      totalAudioCount: 0,
    }));
  },
});

export default slice;
